import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import MyIcon from '@/components/MyIcon.vue'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
      },
      icons: {
        'product': {
          component: MyIcon, 
        }
      }        
});
